export default {
  menuItems: [
    {
      name: "トップ",
      url: "/",
    },
    {
      name: "ストーリー",
      url: "/story",
    },
    {
      name: "商品情報",
      url: "/product",
    },
    // {
    //   name: "ムービー",
    //   url: '/movie',
    // },
    // {
    //   name: "お問い合わせ",
    //   url: "#",
    // },
  ],
};
